function formatTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

const VARIANTS = {
  paciente: {
    align: 'flex-start',
    bg: '#F1F3F5',
    color: '#1A1A2E',
    radius: '4px 12px 12px 12px',
    label: null,
  },
  ia: {
    align: 'flex-end',
    bg: '#E6F1FB',
    color: '#185FA5',
    radius: '12px 4px 12px 12px',
    label: '· IA',
  },
  recepcao: {
    align: 'flex-end',
    bg: '#E1F5EE',
    color: '#0F6E56',
    radius: '12px 4px 12px 12px',
    label: '· Recepção',
  },
  sistema: null,
};

export default function ChatBubble({ mensagem }) {
  const { tipo, conteudo, criado_em } = mensagem;

  if (tipo === 'sistema') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', margin: '4px 0' }}>
        <span style={{
          backgroundColor: '#F1F3F5',
          color: '#ADB5BD',
          borderRadius: '99px',
          fontSize: '11px',
          padding: '2px 12px',
        }}>
          {conteudo}
        </span>
      </div>
    );
  }

  const v = VARIANTS[tipo] ?? VARIANTS.paciente;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: v.align, margin: '4px 0' }}>
      <div style={{
        backgroundColor: v.bg,
        color: v.color,
        borderRadius: v.radius,
        fontSize: '13px',
        padding: '8px 12px',
        maxWidth: '70%',
        lineHeight: '1.4',
        wordBreak: 'break-word',
      }}>
        {conteudo}
      </div>
      <span style={{ fontSize: '11px', color: '#ADB5BD', marginTop: '2px' }}>
        {formatTime(criado_em)}{v.label ? ` ${v.label}` : ''}
      </span>
    </div>
  );
}
